module.exports = __webpack_public_path__ + "static/img/channel_search_item_03.7db40c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/worktype/channel_search_item_03.png
// module id = sz4T
// module chunks = 0